// Customer-facing status labels for orders. Keeps internal state names
// (NEW, VERIFIED, OUT_FOR_DELIVERY, …) out of the UI so shoppers see language
// that matches their expectations.
export const ORDER_STATUS_LABEL = {
  NEW: "Pending confirmation",
  UNDER_REVIEW: "Pending confirmation",
  VERIFIED: "Confirmed",
  PAYMENT_CONFIRMED: "Confirmed",
  READY_FOR_DELIVERY: "Ready for delivery",
  OUT_FOR_DELIVERY: "On the way",
  DELIVERED: "Delivered",
  REJECTED: "Cancelled",
  CANCELLED: "Cancelled",
};

export function orderStatusLabel(status) {
  return ORDER_STATUS_LABEL[status] || status || "Pending confirmation";
}
